import { createAsyncThunk } from "@reduxjs/toolkit";
import fetchAPI from "../../utils/axios";

/**
 * Thunk to create new feature
 * 
 * @async
 * @function registerUser
 * @param {Object} features - The feature object containing feature information.
 * @param {function} thunkAPI - The thunkAPI object provided by Redux Toolkit.
 * @returns {Promise<Object>} Newely created feature's response data or an error message.
 */
export const createFeature = createAsyncThunk(
    'feature/create', async (features, thunkAPI) => {
        try {
            const response = await fetchAPI.post('/features', features);
            return response.data;
        } catch (error) {
            let message = error.response.data.error;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

/**
 * Thunk to get all the features
 * 
 * @async
 * @function registerUser
 * @param {Object} features - The feature object containing feature information.
 * @param {function} thunkAPI - The thunkAPI object provided by Redux Toolkit.
 * @returns {Promise<Object>} Response data for the all features or an error message.
 */
export const getAllFeatures = createAsyncThunk(
    'feature/getAllFeatures', async (features, thunkAPI) => {
        try {
            const response = await fetchAPI.get('/features', features);
            return response.data;
        } catch (error) {
            let message = error.response.data.error;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

/**
 * Thunk to features by the user
 * 
 * @async
 * @function registerUser
 * @param {Object} features - The feature object containing feature information.
 * @param {function} thunkAPI - The thunkAPI object provided by Redux Toolkit.
 * @returns {Promise<Object>} Response data for the feature by the user or an error message.
 */
export const getFeaturesByUser = createAsyncThunk(
    'feature/getFeatureByUser', async (userId, thunkAPI) => {
        try {
            const response = await fetchAPI.get(`features/toggle/${userId}`)
            return response.data;
        } catch (error) {
            let message = error.response.data.error;
            return thunkAPI.rejectWithValue(message);
        }
    }
)

/**
 * Thunk to set feature for the user
 * 
 * @async
 * @function registerUser
 * @param {Object} features - The feature object containing feature information.
 * @param {function} thunkAPI - The thunkAPI object provided by Redux Toolkit.
 * @returns {Promise<Object>} Response data for the feature set for the user or an error message.
 */
export const toggleFeatureForUser = createAsyncThunk(
    'feature/toggleFeatureForUser', async (userId, thunkAPI) => {
        try {
            const response = await fetchAPI.put(`features/toggle/${userId}`)
        } catch (error) {
            let message = error.response.data.error;
            return thunkAPI.rejectWithValue(message);
        }
    }
);

